var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEterOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5232_26796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3674 45.4688V60.0001C23.3989 60.0001 30.0131 53.4376 30.0131 45.4688V30.9375C21.9816 30.9375 15.3674 37.3438 15.3674 45.4688Z",
    fill: "#FF972F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5881 14.5313V29.0626C39.6196 29.0626 46.2338 22.5001 46.2338 14.5313V0C38.2023 0 31.5881 6.56253 31.5881 14.5313Z",
    fill: "#FF972F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5251 15.1567H0.879395C0.879395 23.1255 7.49357 29.6881 15.5251 29.6881H30.1707C30.1707 21.7193 23.5566 15.1567 15.5251 15.1567Z",
    fill: "#FF972F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2338 45.1568H60.8795C60.8795 37.188 54.2653 30.6255 46.2338 30.6255H31.5881C31.5881 38.7505 38.2023 45.1568 46.2338 45.1568Z",
    fill: "#FF972F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5232_26796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.879395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEterOrange);
export default __webpack_public_path__ + "static/media/eter-orange.d68ac6c83c101aa9bee2bee81bc1eaf3.svg";
export { ForwardRef as ReactComponent };